// extracted by mini-css-extract-plugin
export var downArrow = "_97-0";
export var infoTooltipIcon = "_97-3";
export var label = "_97-1";
export var optionCard = "_97-4";
export var upArrow = "_97-2";